import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
interface ProtectedAdminRouteProps {
  children: React.ReactNode;
  requiredPermission?: string;
}
const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({
  children,
  requiredPermission
}) => {
  const {
    isAuthenticated,
    isLoading,
    hasPermission
  } = useAdminAuth();
  // Show loading indicator while checking authentication
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center" data-id="element-175">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600" data-id="element-176"></div>
      </div>;
  }
  // Redirect to admin login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace data-id="element-177" />;
  }
  // Check for required permission if specified
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <div className="min-h-screen flex flex-col items-center justify-center p-4" data-id="element-178">
        <div className="bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-md max-w-lg" data-id="element-179">
          <h2 className="text-lg font-semibold mb-2" data-id="element-180">Access Denied</h2>
          <p data-id="element-181">You don't have the required permissions to access this page.</p>
        </div>
        <button onClick={() => window.history.back()} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-182">
          Go Back
        </button>
      </div>;
  }
  // Render children if authenticated and has permission
  return <>{children}</>;
};
export default ProtectedAdminRoute;